<script setup lang="ts">
// Botão "Fechar" (X) padrão dos modais overlay do Minha Conta V2 (canto
// superior direito) — mesma marcação usada em AchievementModal.vue e
// RewardRedeemModal.vue. Figma node 19831:60693 ("Modal -> Emblemas"): o
// círculo + X são UMA arte só (fundo bg-white/5 e o X já embutidos no
// próprio SVG), sem borda/gradiente separados — por isso o svg abaixo
// reproduz o asset inteiro, não só o traço do X.
defineEmits<{ close: [] }>();
</script>

<template>
  <button
    aria-label="Fechar"
    class="absolute right-[16px] top-[16px] flex size-[30px] items-center justify-center"
    type="button"
    @click="$emit('close')"
  >
    <svg
      fill="none"
      height="30"
      viewBox="0 0 30 30"
      width="30"
    >
      <rect
        fill="white"
        fill-opacity="0.05"
        height="30"
        rx="15"
        width="30"
      />
      <path
        d="M19.2784 12.1583L20 11.4399L18.5601 10L17.8417 10.7184L15 13.5601L12.1583 10.7184L11.4399 10L10 11.4399L10.7184 12.1583L13.5601 15L10.7216 17.8417L10 18.5601L11.4399 20L12.1583 19.2816L15 16.4399L17.8417 19.2816L18.5601 20L20 18.5601L19.2816 17.8417L16.4399 15L19.2816 12.1583H19.2784Z"
        fill="white"
      />
    </svg>
  </button>
</template>
